import React, { Component } from "react";
import * as BooksAPI from "./BooksAPI";
import Book from "./Book";
import { Link } from "react-router-dom";

class SearchPage extends Component {
  state = {
    query: "",
    searchedBooks: [],
  };

  updateQuery = (query) => {
    this.setState({ query });
    this.updateSearchedBooks(query);
  };

  updateSearchedBooks = (query) => {
    if (query) {
      BooksAPI.search(query).then((searchedBooks) => {
        // no books found here or any other error
        if (searchedBooks.error) {
          //no result
          this.setState({ searchedBooks: [] });
        } else {
          this.setState({ searchedBooks });
        }
      });
    } else {
      //no result
      this.setState({ searchedBooks: [] });
    }
  };

  render() {
    return (
      <div className="search-books">
        <div className="search-books-bar">
          <Link to="/" className="close-search">
            Close
          </Link>

          <div className="search-books-input-wrapper">
            <input
              type="text"
              placeholder="Search by title or author"
              value={this.state.query}
              //controlled function
              onChange={(event) => {
                this.updateQuery(event.target.value);
              }}
            />
          </div>
        </div>
        <div className="search-books-results">
          <ol className="books-grid">
            {this.state.searchedBooks.map((searchedbook) => {
              let shelfName = "none";

              this.props.books.map((book) =>
                book.id === searchedbook.id ? (shelfName = book.shelf) : ""
              );

              return (
                <li key={searchedbook.id}>
                  <Book
                    book={searchedbook}
                    moveShelf={this.props.moveShelf}
                    currentShelf={shelfName}
                  />
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    );
  }
}

export default SearchPage;
